var _NotificationServiceI;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import InfoCircleIcon from '@shazambanking/icons/InfoCircleIcon';
import ExclamationCircleIcon from '@shazambanking/icons/ExclamationCircleIcon';
import ExclamationTriangleIcon from '@shazambanking/icons/ExclamationTriangleIcon';
import CheckCircleIcon from '@shazambanking/icons/CheckCircleIcon';
import TimesIcon from '@shazambanking/icons/TimesIcon';
import { icon } from '@fortawesome/fontawesome-svg-core';
import { NotificationType } from './types';
/**
 * This is very brittle and should be changed as soon as possible. This is an interim fix to use same icons in web-icons
 * Since our notifications aren't in react, we can't utilize the react components. This will remove the dependency on our fa license
 */

export var NotificationServiceIcons = (_NotificationServiceI = {}, _defineProperty(_NotificationServiceI, NotificationType.Warning, icon(ExclamationTriangleIcon({}).props.icon).html), _defineProperty(_NotificationServiceI, NotificationType.Error, icon(ExclamationCircleIcon({}).props.icon).html), _defineProperty(_NotificationServiceI, NotificationType.Success, icon(CheckCircleIcon({}).props.icon).html), _defineProperty(_NotificationServiceI, NotificationType.Info, icon(InfoCircleIcon({}).props.icon).html), _defineProperty(_NotificationServiceI, "close", icon(TimesIcon({}).props.icon).html), _NotificationServiceI);
export function getStatusIcon(type) {
  if (type) {
    return NotificationServiceIcons[type];
  }

  return null;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@shazambanking/sdk/services/notifications/icons.js
// module id = 609
// module chunks = 0